import WWMuffinsProduct from 'models/WWMuffinsProduct'

export const packagingInitialState = {
  category: WWMuffinsProduct.category,
  subCategory: WWMuffinsProduct.subCategory,
  Size: WWMuffinsProduct.Size,
  WholeWheatCert: WWMuffinsProduct.WholeWheatCert,
}